import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDrawer} from '@angular/material';

@Component({
  selector: 'app-console',
  templateUrl: './console.component.html',
  styleUrls: ['./console.component.scss']
})
export class ConsoleComponent implements OnInit {

  partner: any;
  email: any;

  sideNavContent: any;
  contentFlag: any;
  @ViewChild('drawer', { static: true }) public drawer: MatDrawer;

  consoleData = [
    {
      title: 'Get Started',
      cards: [
        {
          id: 0,
          title: 'Hello World Application',
          description: 'Create your first custom application and deploy it as an API',
          image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/earth.png',
          links: [
            {
              linkIcon: 'fa fa-download',
              linkName: 'Import',
              linkFor: 'hello-world-import',
              link: ''
            },
            {
              linkIcon: 'fa fa-youtube-play',
              linkName: 'Video',
              linkFor: 'hello-world-video',
              link: ''
            },
            {
              linkIcon: 'fa fa-file-text',
              linkName: 'Documentation',
              linkFor: 'hello-world-documentation',
              link: ''
            }
          ],
          documentation: {
            documentationTitle: 'Creating a Simple Hello World Business Logic API',
            documentationStarter: 'Learn how to create a simple “Hello World” Business Logic API',
            steps: [
              {
                stepNumber: '1',
                stepDescription: 'Start by logging into your DEV environment and then click on Create in the navigation sidebar.'
              },
              {
                stepNumber: '2',
                stepDescription: 'Select Business Logic API from the options provided.'
              },
              {
                stepNumber: '3',
                stepDescription: 'This brings up the Business Logic Builder , where you can start by entering the API details. Provide the API name as Hello, the version as V1, the executor method type as GET, and the category as Test.'
              },
              {
                stepNumber: '4',
                stepDescription: 'Choose the default API gateway and set the display name to be the same as the API name and provide a basic description.'
              },
              {
                stepNumber: '5',
                stepDescription: 'All logic blocks required to create a business logic API are available on the left. Click on the Core logic builder and select variables. Click on a Create variable and name the variable as Text. Select the Set to variable block from the different blocks shown. Now we need to assign a string to the empty variable. For this click on the Text category and select the string block denoted by a blank space within quotes. Enter “Hello World” inside the string block.'
              },
              {
                stepNumber: '6',
                stepDescription: 'Under the API builder category, click API return and select the return block. Drag the return block under the set to variable block. From the variables section under the core logic builder, select the Text variable block and place it sequentially with the return block.'
              },
              {
                stepNumber: '7',
                stepDescription: 'We are now done building our API. Select the test option on the right and click on run to test the API. After assessing the API output, click on save and then deploy your API. You can find your deployed API in the control plane under business logic API section.'
              }
            ],
            documentCloser: 'The business logic builder enables creation of the simplest APIs and simplifies complex integrations'
          },
          videos: [
            {
              videoLink: 'XnRxrawCtKM',
              videoName: 'Business Logic Builder'
            }
          ]
        },
        {
          id: 1,
          title: ' Design to Launch in minutes',
          description: 'Create and launch fully functional backend application from Open API Specification',
          image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/design.png',
          links: [
            {
              linkIcon: 'fa fa-download',
              linkName: 'Import',
              linkFor: 'design-import',
              link: ''
            },
            {
              linkIcon: 'fa fa-youtube-play',
              linkName: 'Video',
              linkFor: 'design-video',
              link: ''
            },
            {
              linkIcon: 'fa fa-file-text',
              linkName: 'Documentation',
              linkFor: 'design-documentation',
              link: ''
            }
          ],
          documentation: {
            documentationTitle: 'Generating APIs from OpenAPI',
            documentationStarter: 'Learn how to generate APIs from an OpenAPI Spec.',
            steps: [
              {
                stepNumber: '1',
                stepDescription: 'Start by logging into your DEV environment and then navigate to the create option on the left navigation sidebar. Scroll down to the generate from section and click OpenAPI. You will be redirected to the Create from Open API editor'
              },
              {
                stepNumber: '2',
                stepDescription: 'Here, you can specify the OpenAPI specification version and write your own OpenAPI Spec or you can upload a yaml file by clicking on the upload file button. Please note that filenames cannot contain floating characters.'
              },
              {
                stepNumber: '3',
                stepDescription: 'After writing your OpenAPI spec or uploading your yaml file, you can view the deployment plan by clicking the show deployment plan button on the top right.'
              },
              {
                stepNumber: '4',
                stepDescription: 'From the deployment plan, you can select which APIs to deploy and then click next.'
              },
              {
                stepNumber: '5',
                stepDescription: 'Here you can configure your databases, gateways and descriptions for each API being deployed or you can choose to stay with the default options provided. Please note that API version names cannot contain special characters. You can then save the deployment plan and deploy the APIs. You can click on deployment logs to view API deployment details.'
              },
              {
                stepNumber: '6',
                stepDescription: 'You can find the APIs generated from OpenAPI in the control plane under the Applications tab.'
              }
            ],
            documentCloser: 'Convert your OpenAPI specs to APIs in minutes with apiplatform.io.'
          },
          videos: [
            {
              videoLink: '8ysBRce5V40',
              videoName: 'OpenAPI'
            }
          ]
        },
        {
          id: 2,
          title: 'Transform Legacy Data as APIs',
          description: 'Launch fully functional APIs for database tables, views, procedures, etc. with no code',
          image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/transform.png',
          links: [
            {
              linkIcon: 'fa fa-download',
              linkName: 'Import',
              linkFor: 'transform-import',
              link: ''
            },
            {
              linkIcon: 'fa fa-youtube-play',
              linkName: 'Video',
              linkFor: 'transform-video',
              link: ''
            },
            {
              linkIcon: 'fa fa-file-text',
              linkName: 'Documentation',
              linkFor: 'transform-documentation',
              link: ''
            }
          ],
          documentation: {
            documentationTitle: 'Database Transformation to APIs',
            documentationStarter: 'Learn how to transform your database to APIs',
            steps: [
              {
                stepNumber: '1',
                stepDescription: 'Start by logging into your DEV environment and then navigate to the Create page. Click on Database in the Create sidebar menu.'
              },
              {
                stepNumber: '2',
                stepDescription: 'This brings up the Data Catalog. On the left menu panel, you can see the list of database connections. If you don’t have one, you can start by creating a new database connection by clicking on ‘+’ icon. This brings up a dialog where you can create connections to different types of databases supported by apiplatform by providing the appropriate details.'
              },
              {
                stepNumber: '3',
                stepDescription: 'Upon expanding a database connection, you can see the list of databases available in the selected connection. Further expanding the database, you can see the Tables, Views, Indexes, Triggers and Procedures that are available in the selected database. On selecting a particular database, you can see Properties, ER Diagram and Deploy as API options as multiple tabs.'
              },
              {
                stepNumber: '4',
                stepDescription: 'Under Properties tab, you can view Tables, Views, Indexes, Triggers and Procedures that are present in the selected database. Under ER Diagram, you can see the entity relationship diagram of the database. Under Deploy as API tab, you can choose from the list of transformation options and the target database. Click on show deployment plan. You can review the list of database objects that will transformed to APIs. Click on Deploy APIs. Once the deployment is done, a summary of the deployment process will be shown. The deployed API(s) can be found in control plane.'
              },
              {
                stepNumber: '5',
                stepDescription: 'If you wish to transform individual database objects to APIs rather than whole database, you can click on the particular database object under the selected database from the left panel and the deployment process is same as the database.'
              },
              {
                stepNumber: '6',
                stepDescription: 'Under the API builder category, click API return and select the return block. Drag the return block under the set to variable block. From the variables section under the core logic builder, select the Text variable block and place it sequentially with the return block.'
              },
              {
                stepNumber: '7',
                stepDescription: 'We are now done building our API. Select the test option on the right and click on run to test the API. After assessing the API output, click on save and then deploy your API. You can find your deployed API in the control plane under business logic API section.'
              }
            ],
            documentCloser: ''
          },
          videos: [
            {
              videoLink: '3CkLIfwY0sY',
              videoName: 'Database'
            }
          ]
        },
        {
          id: 3,
          title: 'Build Complex Workflows',
          description: 'Build, test and deploy complex workflows just by few clicks and configurations',
          image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/build.png',
          links: [
            {
              linkIcon: 'fa fa-download',
              linkName: 'Import',
              linkFor: 'build-import',
              link: ''
            },
            {
              linkIcon: 'fa fa-youtube-play',
              linkName: 'Video',
              linkFor: 'build-video',
              link: ''
            },
            {
              linkIcon: 'fa fa-file-text',
              linkName: 'Documentation',
              linkFor: 'build-documentation',
              link: ''
            }
          ],
          documentation: {
            documentationTitle: 'Using the Workflow Builder',
            documentationStarter: 'Learn how to design workflows using the Workflow Builder in apiplatform.io.',
            steps: [
              {
                stepNumber: '1',
                stepDescription: 'Start by logging into your DEV environment, click on the Create option on the left navigation sidebar and select the workflow builder.'
              },
              {
                stepNumber: '2',
                stepDescription: 'For this, we will take up a case of crediting interest to a customer’s account based on the customer’s deposit type.'
              },
              {
                stepNumber: '3',
                stepDescription: 'Click on the Add diagram button to get started, you can either import ta BPMN format workflow diagram or import a diagram from an S3 storage bucket.'
              },
              {
                stepNumber: '4',
                stepDescription: 'Click on create blank diagram to get started with our own custom workflow diagram.'
              },
              {
                stepNumber: '5',
                stepDescription: 'Fill in the required fields such as API name, version, executor method type, category, display name and description. We are now ready to start creating our workflow diagram.'
              },
              {
                stepNumber: '6',
                stepDescription: 'You can either drag a process element from the task menu on the left or you can click on the default StartEvent element and different options will appear. We will click on the startevent element and then select the task element to add it to the diagram.'
              },
              {
                stepNumber: '7',
                stepDescription: 'In the same way, we will add an exclusive gateway to the diagram. We will continue to add tasks to the diagram and close the workflow diagram with an EndEvent element'
              },
              {
                stepNumber: '8',
                stepDescription: 'We will now need to assign the type of task for each element. To assign the task type click on the element and select the change type option depicted by the wrench icon. We will now select the User task option for this task element.'
              },
              {
                stepNumber: '9',
                stepDescription: 'In the same way, we will assign the task type for all the required task elements. We can also name each element to represent their usage by double clicking on the element and then entering a suitable name.'
              },
              {
                stepNumber: '10',
                stepDescription: 'Now, we will select the startevent element again. We can see a contextual menu on the right with multiple tabs where we can perform a variety of actions such as adding properties inside the Extension tab, adding execution listeners in the Listeners tab, etc. For now we are going to use the Forms tab and add form fields.'
              },
              {
                stepNumber: '11',
                stepDescription: 'We can add a form field by clicking on the plus sign and entering the field name inside the ID box and selecting the form type from the dropdown menu. For now, we will select the string type. Similarly, we will add Contact, Deposit_Type and Deposit_Amount fields.'
              },
              {
                stepNumber: '12',
                stepDescription: 'Now based on the Deposit type we will route to either the Fixed Deposit, Annual Deposit or Quarterly Deposit task elements.'
              },
              {
                stepNumber: '13',
                stepDescription: 'Clicking on the routing arrow of the Fixed deposit user task will bring up another contextual menu on the right with 3 tabs – General, Listeners and Extensions. In the General tab we will select the expression option from the Condition dropdown menu.'
              },
              {
                stepNumber: '14',
                stepDescription: 'In the Expression field we will provide the expression ${Deposit_Type==”FD”}, where FD represents Fixed Deposits. In the same way we will route to the other deposit types.'
              },
              {
                stepNumber: '15',
                stepDescription: 'We can download the workflow diagram in the bpmn format or svg format or save it to an S3 bucket. We will now save the API. We can also execute our API using the execute option.'
              },
              {
                stepNumber: '16',
                stepDescription: 'We will now deploy our API by clicking Deploy. Once the API is deployed the API endpoint is displayed on the screen. We can find the deployed API under the workflow API tab in the control plane.'
              }
            ],
            documentCloser: 'Build your workflow APIs easily using apiplatform.io'
          },
          videos: [
            {
              videoLink: 'YhoL7gBLrZE',
              videoName: 'Workflow'
            }
          ]
        }
      ]
    },
    {
      title: 'Navigate',
      cards: [
        {
          id: 0,
          title: 'Control Plane',
          description: 'Central hub for platform activity offers insights into file storage, summarizes APIs, including third-party registrations',
          link: 'controlplane',
          links: null,
          documentation: null,
          videos: null,
          image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/control.png'
        },
        {
          id: 1,
          title: 'API Monitors',
          description: 'Identifying outages and subpar API calls is crucial for enhancing reliability, uptime, and performance',
          link: 'monitors',
          links: null,
          documentation: null,
          videos: null,
          image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/monitor.png'
        },
        {
          id: 2,
          title: 'Alerts',
          description: 'Implement alert permissions for conveying information to developers and administrators',
          link: 'alerts',
          links: null,
          documentation: null,
          videos: null,
          image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/bell.png'
        },
        {
          id: 3,
          title: 'Developer Experience',
          description: 'A software tool is functional, usable, well-designed, self-service, and easy to navigate',
          link: 'devex',
          links: null,
          documentation: null,
          videos: null,
          image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/experience.png'
        },
      ]
    },
    {
      title: 'API Builders',
      cards: [
        {
          id: 0,
          title: 'Data as a Service',
          link: 'dataaccessapi',
          links: null,
          documentation: null,
          videos: null,
          description: 'Convert your schema into fully functional CRUD APIs',
          image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/dataService_hex.png',
        },
        {
          id: 1,
          title: 'Application Logic',
          link: 'businesslogic',
          links: null,
          documentation: null,
          videos: null,
          description: 'Play with blocks to build application integrations and complex programs',
          image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/applicationLogic_hex.png',
        },
        {
          id: 2,
          title: 'Workflows',
          link: 'workflow',
          links: null,
          documentation: null,
          videos: null,
          description: 'Leverage the power of Camunda and BPMN editor to build complex human workflows',
          image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/workflow_hex.png',
        },
        {
          id: 3,
          title: 'SQL as a Service',
          link: 'querybuilder',
          links: null,
          documentation: null,
          videos: null,
          description: 'Leverage the power of Camunda and BPMN editor to build complex human workflows',
          image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/sql2api2_hex.png',
        }
      ]
    },
    {
      title: 'Connectors',
      cards: [
        {
          id: 0,
          title: 'Databases',
          link: 'databases',
          links: null,
          documentation: null,
          videos: null,
          description: 'Enables users to convert the database table into an API',
          image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/database.png',
        },
        {
          id: 1,
          title: 'API Providers',
          link: 'providers',
          links: null,
          documentation: null,
          videos: null,
          description: 'API Providers are utilized to establish connections to service providers to use their APIs',
          image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/providers.png',
        },
        {
          id: 2,
          title: 'Files',
          link: 'filestorage',
          links: null,
          documentation: null,
          videos: null,
          description: 'Provides users a storage to manage their files in the cloud',
          image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/files.png',
        }
      ]
    },
    {
      title: 'Tools',
      cards: [
        {
          id: 0,
          title: 'Data Catalog',
          link: 'datacatalog',
          links: null,
          documentation: null,
          videos: null,
          description: 'Manage databases and their catalogs declaratively',
          image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/data.png',
        },
        {
          id: 1,
          title: 'API Query Language',
          link: 'apiql',
          links: null,
          documentation: null,
          videos: null,
          description: 'Single end point to access all data APIs',
          image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/query.png',
        },
        {
          id: 2,
          title: 'Email Template Builder',
          link: 'email-templates',
          links: null,
          documentation: null,
          videos: null,
          description: 'Build emails using rich interfaces and expose them as APIs',
          image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/email.png',
        },
        {
          id: 3,
          title: 'API Test Builder',
          link: 'apiql',
          links: null,
          documentation: null,
          videos: null,
          description: 'Visual test suite builder for APIs with assertions difned declaratively',
          image: 'https://s3.amazonaws.com/apiplatformio-assets/assets/console/test.png',
        }
      ]
    }
  ];

  constructor() { }

  ngOnInit() {
    this.partner = localStorage.getItem('partner');
    this.email = localStorage.getItem('signInEmail');
  }

  setSideNavContent(linkFor: string) {
    switch (linkFor) {
      case 'hello-world-video' :
        this.contentFlag = false;
        this.sideNavContent = this.consoleData[0].cards[0].videos;
        if (!this.isSideNavOpen()) {
          this.showSideNav();
        }
        break;
      case 'hello-world-documentation' :
        this.contentFlag = true;
        this.sideNavContent = this.consoleData[0].cards[0].documentation;
        if (!this.isSideNavOpen()) {
          this.showSideNav();
        }
        break;
      case 'design-video' :
        this.contentFlag = false;
        this.sideNavContent = this.consoleData[0].cards[1].videos;
        if (!this.isSideNavOpen()) {
          this.showSideNav();
        }
        break;
      case 'design-documentation' :
        this.contentFlag = true;
        this.sideNavContent = this.consoleData[0].cards[1].documentation;
        if (!this.isSideNavOpen()) {
          this.showSideNav();
        }
        break;
      case 'transform-video' :
        this.contentFlag = false;
        this.sideNavContent = this.consoleData[0].cards[2].videos;
        if (!this.isSideNavOpen()) {
          this.showSideNav();
        }
        break;
      case 'transform-documentation' :
        this.contentFlag = true;
        this.sideNavContent = this.consoleData[0].cards[2].documentation;
        if (!this.isSideNavOpen()) {
          this.showSideNav();
        }
        break;
      case 'build-video' :
        this.contentFlag = false;
        this.sideNavContent = this.consoleData[0].cards[3].videos;
        if (!this.isSideNavOpen()) {
          this.showSideNav();
        }
        break;
      case 'build-documentation' :
        this.contentFlag = true;
        this.sideNavContent = this.consoleData[0].cards[3].documentation;
        if (!this.isSideNavOpen()) {
          this.showSideNav();
        }
        break;
      default:
        this.sideNavContent = null;
          break;
    }
  }

  isSideNavOpen() {
    return this.drawer.opened;
  }

  showSideNav() {
    this.drawer.toggle();
  }
}
